export const getFirebaseStyles = (theme) => ({
    '.firebaseui-container.mdl-card': {
        boxShadow: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '.firebaseui-container .mdl-button--primary.mdl-button--primary, .firebaseui-container .firebaseui-link': {
        color: theme.palette.primary.main,
    },
    ['.firebaseui-container .mdl-button--raised.mdl-button--colored,' +
    '.firebaseui-container .mdl-button--raised.mdl-button--colored:hover,' +
    '.firebaseui-container .firebaseui-textfield.mdl-textfield .firebaseui-label:after,' +
    '.firebaseui-container .mdl-button--raised.mdl-button--colored:active']: {
        background: theme.palette.primary.main,
    },

    ['.firebaseui-container .firebaseui-card-header,' +
    '.firebaseui-container .firebaseui-card-content,' +
    '.firebaseui-container .firebaseui-card-actions']: {
        padding: 0,
    },
    '.firebaseui-container .firebaseui-tos': {
        display: 'none',
    },
    '.firebaseui-idp-list': {
        margin: theme.spacing(0),
        padding: theme.spacing(1.5, 2),
    },
    '.firebaseui-container .firebaseui-list-item': {
        marginBottom: theme.spacing(0),
        '&:not(:last-child)': {
            marginBottom: theme.spacing(1.5),
        },
    },
    '.firebaseui-container .mdl-button': {
        padding: theme.spacing(1.5, 2),
        height: 'auto',
        lineHeight: 1.5,
        borderRadius: theme.spacing(2),
        boxShadow: `inset 0 0 0 1px rgba(0,0,0,0.1)`,
    },
});
